// Code review - Completed
// Documentation - Completed
import { useState, useEffect } from "react";
import { mainTable } from "../css/Common";
import { roleMasterExcelExportHeader, roleMasterHeader } from "../components/HeaderAttribute";
import MainPopup from "../popup-containers/MainPopup";
import MainLayout from "../components/MainLayout";
import InputText from "../ReusableComponents/InputText";
import TextArea from "../ReusableComponents/TextArea";
import Role from "../popup-containers/RolePopup";
import toast from "react-hot-toast";
import { BindAPI, IUDAPI } from "../services/APIConnection";
import GridPage from "../components/GridPage";
import AddScreenTitle from "../components/AddScreenTitle";
import Buttons from "../components/Buttons";
import PopUpButtons from "../components/PopUpButtons";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import { useLocation } from "react-router-dom";
import ErrorPopup from "../ReusableComponents/ErrorPopup";
import Loader from "../ReusableComponents/Loader";
import * as XLSX from "sheetjs-style";

const RoleMaster = () => {
  const location = useLocation();
  //All visible functionality useState hooks handling.
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  const [viewDetails, setViewDetails] = useState(false);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [visibleUpdate, setVisibleUpdate] = useState(false);

  // Role Master insert and edit useState hooks handling .
  const [mstRoleId, setMstRoleId] = useState("");
  const [roleData, setRoleData] = useState("");
  const [bindRoleMasterDatas, setbindRoleMasterDatas] = useState([]);

  // Rowindex, Popup, Pagination, next page and other some useState hooks handling.
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [rowIndex, setRowIndex] = useState("");
  const [editMode, setEditMode] = useState([]);
  const [isOpen, setIsOpen] = useState(false);

  // This function is helping for Popup open .
  const handleOpen = (isOpen) => {
    setpopUpOpen(isOpen);
  };

  //Value store States
  const [roleFields, setRoleFields] = useState({
    roleGroups: "",
    description: "",
  });

  const [roleFieldsError, setRoleFieldsError] = useState({
    roleGroupsError: "",
    descriptionError: "",
  });

  // This is grid page add button visible handling functionality .
  const showAdd = () => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setUpdateScreenTitle(false);
    setAddScreenTitle(true);
    setVisibleUpdate(false);
  };

  // This is ovrall cancel button visible handling functionality .
  const cancel = async () => {
    setVisibleAdd(false);
    setVisibleTable(true);
    handleOpen(false);
    setSubmitBtnDisabled(false);
    setRoleFields({
      roleGroups: "",
      description: "",
    });

    setRoleFieldsError({
      roleGroupsError: "",
      descriptionError: "",
    });
    RoleDatas();
    setIsLoading(false);
  };

  //This is Role Master grid data bind functionality.
  useEffect(() => {
    RoleDatas();
  }, []);

  const RoleDatas = async () => {
    setIsLoading(true);
    try {
      const response = await BindAPI("RoleAPI/BindRole");
      setbindRoleMasterDatas(response?.data?.Table ?? []);
    } catch (error) {
      console.error("Error fetching roles:", error);
      setbindRoleMasterDatas([]); // fallback in case of error
    } finally {
      setIsLoading(false);
    }
  };

  // this function is helped to the viwe, delete, block and unblock input value via rowindex passing.
  const handleRole = (rowIndex, flag) => {
    handleOpen(true);
    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
      setRowIndex(rowIndex);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setRowIndex(rowIndex);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setRowIndex(rowIndex);
      setUnBlockDetails(true);
    }
    setRoleData(bindRoleMasterDatas[rowIndex]);
  };

  // this function is helped to edit the input value via rowindex passing and helping to visible handling.
  const handleEdit = (rowIndex) => {
    setEditMode(true);
    setVisibleUpdate(true);
    setUpdateScreenTitle(true);
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(false);
    setRoleFields({
      roleGroups: bindRoleMasterDatas[rowIndex].RoleName,
      description: bindRoleMasterDatas[rowIndex].RoleDiscription,
    });
    setMstRoleId(bindRoleMasterDatas[rowIndex].MstRoleId);
  };

  const validate = (flag) => {
    const errors = {};
    if (flag === 1 || flag === 2) {
      if (!roleFields.roleGroups.trim()) {
        errors.roleGroups = "Enter Role / Groups";
      }
    }
    setRoleFieldsError({
      ...roleFieldsError,
      roleGroupsError: errors.roleGroups || "",
    });
    return errors;
  };
  // this function is helped to the edit, viwe, delete, block and unblock flag passing and hanling the API response for those all and passing the rowindex.
  // const createdBy = sessionStorage.getItem("createdBy");
  const handleSubmit = async (items, flag) => {
    setSubmitBtnDisabled(true);
    setIsLoading(true);
    const validation = validate(flag);
    if (Object.keys(validation).length !== 0) {
      setIsOpen(true);
    }
    if (Object.keys(validation).length === 0) {
      setIsOpen(false);
      var createdBy = sessionStorage.getItem("createdBy");
      if (flag == 1 || flag == 2) {
        const data = {
          mstRoleId: mstRoleId ? mstRoleId : 0,
          roleName: roleFields.roleGroups,
          roleDiscription: roleFields.description,
          createdBy: createdBy,
          flag: flag,
        };
        const response = await IUDAPI([data], "RoleAPI/IUDRole");
        if (flag == 1) {
          if (response.data.Table[0].Result === "S") {
            toast.success("New role added successfully! 👍", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
            RoleDatas();
          } else {
            toast.error("Role creation failed 👎", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          }
        } else if (flag == 2) {
          if (response.data.Table[0].Result === "M") {
            toast.success("Role modified successfully! 👍", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
            RoleDatas();
          } else {
            toast.error("Role modification failed 👎", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          }
        }
      } else {
        const data = {
          mstRoleId: bindRoleMasterDatas[items].MstRoleId,
          createdBy: createdBy,
          flag: flag,
        };
        const response = await IUDAPI([data], "RoleAPI/IUDRole");
        if (flag == 3) {
          if (response.data.Table[0].Result === "D") {
            toast.success("Role deleted successfully! 👍", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
            RoleDatas();
          } else {
            toast.error("Role deletion failed 👎", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          }
        } else if (flag == 4) {
          if (response.data.Table[0].Result === "B") {
            toast.success("Role blocked successfully! 👍", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
            RoleDatas();
          } else {
            toast.error("Role blocking failed 👎", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          }
        } else if (flag == 5) {
          if (response.data.Table[0].Result === "UB") {
            toast.success("Role activated successfully! 👍", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
            RoleDatas();
          } else {
            toast.error("Role activated failed! 👎", {
              duration: 1000,
              position: "top-center",
            });
            setTimeout(cancel, 1000);
          }
        }
      }
    } else {
      setSubmitBtnDisabled(false);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (location.pathname == "/rolemaster") {
      setAddScreenTitle(false);
      setVisibleTable(true);
      setVisibleAdd(false);
      RoleDatas();
    }
  }, [location]);


  const handleExport = async () => {
    const locationResponse = await BindAPI("RoleAPI/ExcelExportRole");



    // ✅ EXPORT WITH LOCAL DATA (IMMEDIATE)
    exportData(
      roleMasterExcelExportHeader.map((column) => column.title),
      locationResponse.data.Table
    );
  };


  const exportData = (columns, rows, dateRange, selectedDetails) => {
    // Title row configuration
    const titleRow = [
      {
        v: "Role / Groups Master",
        s: {
          font: { bold: true, sz: 16 },
          alignment: { horizontal: "left" },
        },
      },
    ];




    // Add "Row Total" to headers
    const headerRow = [
      ...columns.map((column) => ({
        v: column,
        s: {
          fill: { fgColor: { rgb: "2D2D6E" } },
          font: { bold: true, color: { rgb: "FFFFFF" } },
          alignment: { horizontal: "left" },
        },
      })),

    ];



    const dataRows = rows.map((rowData, index) => {
      const isAlternateRow = index % 2 === 1;
      const rowStyle = isAlternateRow
        ? { fill: { fgColor: { rgb: "F0F0F0" } } }
        : {};

      return [
        { v: index + 1, s: rowStyle },
        { v: rowData.MstRoleId, s: rowStyle },
        { v: rowData.RoleName, s: rowStyle },
        { v: rowData.RoleDiscription, s: rowStyle },
        { v: rowData.CreatedByName, s: rowStyle },

        
      ];
    });



    // Combine all rows
    const wsData = [
      titleRow,
      headerRow,
      ...dataRows,
    ];
    // const wsData = [headerRow, ...dataRows];
    const ws = XLSX.utils.aoa_to_sheet(wsData);

    // Set custom column widths
    ws["!cols"] = [
      { width: 8 }, // Index
      { width: 20 }, // Branch
      { width: 20 }, // Branch
      { width: 30 }, // Services
      { width: 50 }, // Services
    ];

    ws["!rows"] = [
      { hpt: 30 }, // Title row height
      { hpt: 15 }, // Date range row height
      { hpt: 15 }, // Branch row height (taller for wrapped content)
      { hpt: 15 }, // Spacing row height
      { hpt: 15 }, // Header row height (taller for wrapped content)
      ...Array(rows.length).fill({ hpt: 15 }), // Data rows height
      { hpt: 15 }, // Totals row height
    ];

    // Apply borders and styles
    const applyStyles = (ws) => {
      const range = XLSX.utils.decode_range(ws["!ref"]);
      for (let R = range.s.r; R <= range.e.r; R++) {
        for (let C = range.s.c; C <= range.e.c; C++) {
          const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
          if (!ws[cellRef]) continue;

          // Add borders to all cells
          ws[cellRef].s = {
            ...ws[cellRef].s,
            border: {
              top: { style: "thin", color: { rgb: "000000" } },
              bottom: { style: "thin", color: { rgb: "000000" } },
              left: { style: "thin", color: { rgb: "000000" } },
              right: { style: "thin", color: { rgb: "000000" } },
            },
          };
        }
      }
    };

    applyStyles(ws);

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "Role / Groups Master.xlsx");
  };

  return (
    <MainLayout pageName="2">
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && (
        <GridPage
          title="Role / Groups Master"
          header={roleMasterHeader}
          records={bindRoleMasterDatas}
          handleEdit={handleEdit}
          handleAction={handleRole}
          showAdd={showAdd}
          blockView={true}

          handleExport={handleExport}
          handleExportBtn={true}
        />
      )}
      {visibleAdd && (
        <div class="flex flex-col w-full">
          <div class={mainTable.mainAddScreen}>
            <AddScreenTitle
              addScreenTitle={addScreenTitle}
              updateScreenTitle={updateScreenTitle}
              title="Role / Groups Master"
            />
          </div>

          <div class="mx-auto  md:w-2/5 w-full">
            <div class="relative w-full h-full max-w-xl md:h-auto">
              <div class="relative bg-white rounded-lg shadow ">
                <div class="px-6 py-6 lg:px-8">
                  <form class="space-y-6" action="#">
                    <InputText
                      classStar="text-red-500"
                      inputType={"text"}
                      title={"Role / Groups"}
                      name={"rolegroups"}
                      content={roleFields.roleGroups}
                      controlFunc={(e) =>
                        setRoleFields({
                          ...roleFields,
                          roleGroups: e.target.value,
                        })
                      }
                      controlFuncBlur={(e) => {
                        setRoleFieldsError((roleFieldsError) => ({
                          ...roleFieldsError,
                          roleGroupsError:
                            roleFields.roleGroups &&
                              roleFields.roleGroups.length > 0
                              ? !visibleUpdate &&
                                bindRoleMasterDatas.find(
                                  (x) =>
                                    x.RoleName.toLowerCase() ==
                                    roleFields.roleGroups
                                )
                                ? "Role / Group code already available"
                                : ""
                              : "Enter Role / Groups",
                        }));
                      }}
                      errorMessage={roleFieldsError.roleGroupsError}
                    />

                    <TextArea
                      inputType="text"
                      title="Description"
                      name="description"
                      rows={4}
                      content={roleFields.description}
                      controlFunc={(e) =>
                        setRoleFields({
                          ...roleFields,
                          description: e.target.value,
                        })
                      }
                    />

                    <Buttons
                      addScreenTitle={addScreenTitle}
                      updateScreenTitle={updateScreenTitle}
                      handleSubmit={handleSubmit}
                      cancel={cancel}
                      disabledBtn={submitBtnDisabled ? true : false}
                    />
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={handleRole}
      >
        <div>
          <PopUpScreenTitle
            title="Role / Groups Master"
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />

          <Role data={roleData} />
        </div>

        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          rowIndex={rowIndex}
          handleSubmit={handleSubmit}
          cancel={cancel}
          disabledBtn={submitBtnDisabled ? true : false}
        />
      </MainPopup>
    </MainLayout>
  );
};

export default RoleMaster;
